import React, { useState } from "react";
import EvolutionBarr from "./EvolutionBarr";

function PokemonCard(props) {
  /****        Déclaration des variables      ****/
  const { pokemonSelected, colorTitle } = props;
  const [secondEvolutionExist, setSecondEvolutionExist] = useState(false);

  /*****************************************************/
  /****                 Dom virtuel                 ****/
  /*****************************************************/
  return (
    <div className=" flex flex-col text-center">
      <div className="text-center">
        <h1 className={`my-1 text-lg ${colorTitle} sm:text-4xl `}>
          {pokemonSelected.name} # {pokemonSelected.id}
        </h1>
      </div>

      <div className="flex flex-col items-center sm:flex-row sm:justify-evenly">
        <div className="flex justify-center max-h-[400px]">
          <img src={pokemonSelected.image} alt="pokemon" />
        </div>

        <div className="flex flex-col mt-4 sm:mt-0">
          <div>
            <h1
              className={`displayInitial block text-lg ${colorTitle} sm:my-1 sm:mb-3 sm:text-2xl`}
            >
              -Statistiques-
            </h1>
            <div className="sm:flex sm:justify-center sm:mt-1">
              <ul>
                <li className="text-center rounded-lg mt-2.5 mx-4 mb-4 min-w-[183px] bg-teal-200 sm:max-w-sm">
                  HP : {pokemonSelected.stats.HP}
                </li>
                <li className="text-center rounded-lg mt-2.5 mx-4 mb-4 min-w-[183px] bg-emerald-200 sm:max-w-sm">
                  Attaque : {pokemonSelected.stats.attack}
                </li>
                <li className="text-center rounded-lg mt-2.5 mx-4 mb-4 min-w-[183px] bg-green-200 sm:max-w-sm">
                  Défense : {pokemonSelected.stats.defense}
                </li>
              </ul>
              <ul>
                <li className="text-center rounded-lg mt-2.5 mx-4 mb-4 min-w-[183px] bg-teal-200 sm:max-w-sm">
                  Vitesse : {pokemonSelected.stats.speed}
                </li>
                <li className="text-center rounded-lg mt-2.5 mx-4 mb-4 min-w-[183px] bg-green-200 sm:max-w-sm">
                  Attaque spéciale : {pokemonSelected.stats.special_attack}
                </li>
                <li className="text-center rounded-lg mt-2.5 mx-4 mb-4 min-w-[183px] bg-emerald-200 sm:max-w-sm">
                  Défense spéciale : {pokemonSelected.stats.special_defense}
                </li>
              </ul>
            </div>
          </div>
          <div>
            {/* chaque Div s'affiche en fonction d'une condition */}
            {pokemonSelected.apiEvolutions.length !== 0 ? (
              <h1
                className={`displayInitial block text-lg ${props.colorTitle} sm:my-1 sm:text-2xl`}
              >
                {pokemonSelected.apiEvolutions.length > 1 ||
                secondEvolutionExist
                  ? "-Évolutions-"
                  : "-Évolution-"}
              </h1>
            ) : null}
          </div>
          {pokemonSelected.apiEvolutions.length === 1
            ? pokemonSelected.apiEvolutions.map((elem, index) => (
                <EvolutionBarr
                  key={index}
                  next={elem}
                  colorTitle={colorTitle}
                  setSecondEvolutionExist={setSecondEvolutionExist}
                />
              ))
            : null}
          <div className=" sm:grid grid-cols-2 grid-flow-row gap-4">
            {pokemonSelected.apiEvolutions.length === 2 ||
            pokemonSelected.apiEvolutions.length === 4
              ? pokemonSelected.apiEvolutions.map((elem, index) => (
                  <EvolutionBarr
                    key={index}
                    next={elem}
                    colorTitle={colorTitle}
                    setSecondEvolutionExist={setSecondEvolutionExist}
                  />
                ))
              : null}
          </div>
          <div className=" sm:grid grid-cols-3 grid-flow-row gap-4">
            {pokemonSelected.apiEvolutions.length === 3
              ? pokemonSelected.apiEvolutions.map((elem, index) => (
                  <EvolutionBarr
                    key={index}
                    next={elem}
                    colorTitle={colorTitle}
                    setSecondEvolutionExist={setSecondEvolutionExist}
                  />
                ))
              : null}
          </div>
          <div className=" sm:grid grid-cols-4 grid-flow-row gap-4">
            {pokemonSelected.apiEvolutions.length === 8
              ? pokemonSelected.apiEvolutions.map((elem, index) => (
                  <EvolutionBarr
                    key={index}
                    next={elem}
                    colorTitle={colorTitle}
                    setSecondEvolutionExist={setSecondEvolutionExist}
                  />
                ))
              : null}
          </div>
        </div>
      </div>
    </div>
  );
}

export default PokemonCard;
